// Зеркало App\Enums\UserStatus / AccessMode плюс производный статус «неактивен» (soft delete).
export const USER_STATUS = Object.freeze({
    ACTIVE: 'active',
    PENDING: 'pending',
    INACTIVE: 'inactive',
});

export const USER_STATUS_OPTIONS = Object.freeze([
    { value: USER_STATUS.ACTIVE, label: 'Активные' },
    { value: USER_STATUS.PENDING, label: 'Ожидают' },
    { value: USER_STATUS.INACTIVE, label: 'Неактивные' },
]);

export const ACCESS_MODE = Object.freeze({
    FULL: 'full',
    READONLY: 'readonly',
});

export const MIN_PASSWORD_LENGTH = 8;

export const USER_ACTION = Object.freeze({
    EDIT: 'edit',
    APPROVE: 'approve',
    RESTORE: 'restore',
    DEACTIVATE: 'deactivate',
    RESET_PASSWORD: 'reset-password',
});

export const DRAWER_MODE = Object.freeze({
    CREATE: 'create',
    EDIT: 'edit',
    RESTORE: 'restore',
});

export const userStatusOf = (user) => {
    if (user?.deleted_at) return USER_STATUS.INACTIVE;
    if (user?.status === USER_STATUS.PENDING) return USER_STATUS.PENDING;
    return USER_STATUS.ACTIVE;
};
